// extracted by mini-css-extract-plugin
module.exports = {"childContainer":"styles_childContainer__krkcg","desc":"styles_desc__tdRBX","image":"styles_image__bMVJ0"};